/**
 * 复制文本到剪贴板（全站复制入口共用）。
 *
 * navigator.clipboard 仅在安全上下文（HTTPS / localhost）存在，
 * 局域网 IP + HTTP 访问（如 http://192.168.x.x:5173 的扫码枪）时为 undefined，
 * 直接调用会同步抛 TypeError（.catch 都挂不上）→ 必须先判存在性，
 * 不可用时降级走 execCommand 兜底。
 */

export function copyText(text: string): Promise<void> {
    if (navigator.clipboard && window.isSecureContext) {
        // API 存在但被拒（权限策略/WebView 限制）时也降级兜底
        return navigator.clipboard.writeText(text).catch(() => execCommandCopy(text));
    }
    return Promise.resolve().then(() => execCommandCopy(text));
}

// HTTP 非安全上下文兜底：临时 textarea + execCommand('copy')（已废弃但兼容性最好）
function execCommandCopy(text: string) {
    const ta = document.createElement('textarea');
    ta.value = text;
    // 移出可视区，避免触发页面滚动或闪烁
    ta.style.position = 'fixed';
    ta.style.top = '-9999px';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try {
        if (!document.execCommand('copy')) {
            throw new Error('execCommand copy 返回 false');
        }
    } finally {
        document.body.removeChild(ta);
    }
}
